import type { SelectOption } from '@/types/components/select'
import type { ValuationMethodType } from '@/types/services/global'

export interface ValuationMethodOption extends SelectOption {
  value: ValuationMethodType
}

export const valuationMethodOptions: ValuationMethodOption[] = [
  {
    text: 'Sigil',
    value: '_sigil',
  },
  {
    text: 'Coingecko Average',
    value: 'coingecko_average',
  },
  {
    text: 'Coingecko Origin',
    value: 'coingecko_origin',
  },
]

export const availableValuationMethodOptions: ValuationMethodOption[] =
  valuationMethodOptions.filter((method) => method.value !== '_sigil')
